
import api from '@/api/proxyWeb/bordereauxLivraison'

export default {

    get({ commit }, id) {

        commit('setCurrentBordereauLivraison', null)
        
        return api.get(id)
            .then(facture => {
                commit('setCurrentBordereauLivraison', facture)
            })
    },

    getAll({ commit, rootState }) {
        
        commit('setBordereauxLivraison', null)

        let params = {
            client_id: rootState.clients.currentId,
            site_id: rootState.sites.currentId
        }

        const promise = new Promise(resolve => {
        
            Promise.all([
                api.count(params),
                api.list(params)
            ])
            .then( ([ count, bordereaux ]) => {
                commit('setCount', count)
                commit('setBordereauxLivraison', bordereaux)
                resolve(bordereaux)
            })
        });

        return promise
    },

    getNext({ commit, state, rootState }) {

        let params = {
            client_id: rootState.clients.currentId,
            site_id: rootState.sites.currentId,
            page: state.page + 1 
        }
        
        return api.list(params)
            .then(bordereaux => {
                commit('setNextBordereauxLivraison', bordereaux)
            })
    }   
}